import { Card } from '@acceso/design-system';
import clsx from 'clsx';
import { Dispatch, SetStateAction } from 'react';

import { TProgramBroadcast } from '@/features/broadcast-schedule/types';
import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { TSegment } from '@/features/segments/types';
import { useUnderMinDesktopWidth } from '@/hooks/useUnderMinDesktopWidth';

import { BroadcastScheduleProgramBodySegmentDetailCardBody } from './components/BroadcastScheduleProgramBodySegmentDetailCardBody';
import { BroadcastScheduleProgramBodySegmentDetailCardHeader } from './components/BroadcastScheduleProgramBodySegmentDetailCardHeader';

type TBroadcastScheduleProgramBodySegmentDetailCardProps = {
  items: TSegment[];
  programBroadcast: TProgramBroadcast;
  setSegmentItems: Dispatch<SetStateAction<TSegment[]>>;
};
export function BroadcastScheduleProgramBodySegmentDetailCard({
  items,
  programBroadcast,
  setSegmentItems,
}: TBroadcastScheduleProgramBodySegmentDetailCardProps) {
  const { underMinDesktopWith } = useUnderMinDesktopWidth();

  const { visibleBroadcastProgramCards, pinnedId } = useBroadcastScheduleProgram();

  const allCardsVisible = visibleBroadcastProgramCards.segmentDetail && pinnedId;

  return (
    <Card
      classes={{
        rootSection: clsx(
          '!min-w-full max-w-[35%] w-full flex-auto order-3 lg:order-2 overflow-auto max-h-[600px] lg:max-h-full',
          {
            '!max-w-[500px]': allCardsVisible && underMinDesktopWith,
            '!max-w-[30%]': allCardsVisible && !underMinDesktopWith,
          }
        ),
        container: 'py-size-4',
      }}
      id="parrilla-segments-detail"
    >
      <div className="flex flex-col gap-2">
        <BroadcastScheduleProgramBodySegmentDetailCardHeader />
        <BroadcastScheduleProgramBodySegmentDetailCardBody
          items={items}
          setSegmentItems={setSegmentItems}
          programBroadcast={programBroadcast}
        />
      </div>
    </Card>
  );
}
